import * as React from 'react';
import { Dispatch } from 'react-redux';

import { Button } from '../Thumbnails/Column/ButtonsPanel/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { duplicatePages } from '../../../containers/Editor/actions';

interface ButtonDuplicateSpreadProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonDuplicateSpread = ({ isDisabled, dispatch }: ButtonDuplicateSpreadProps) => (
	<Button
		iconWidth="16px"
		iconHeight="19px"
		disabled={isDisabled}
		onClick={() => dispatch(duplicatePages())}
	>
		{Utils.getSvgIcon('iconset_uprez_duplicate')}
	</Button>
);

export default ButtonDuplicateSpread;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonDuplicateSpread/index.tsx